export default __webpack_public_path__ + "018fa953c1832cd731005d69fa3e7517.svg";